import { ListaSelect } from "../../interfaces/dados-cadastrais/lista-select.interface";

export const LISTA_OPCAO_SEXO: ListaSelect[] = [
    { optLabel: 'Masculino', optValue: 'M' },
    { optLabel: 'Feminino', optValue: 'F' }
]